import {useEffect} from 'react';

export const useDocumentEvent = <T extends keyof DocumentEventMap>(
	eventName: T,
	handler: (event: DocumentEventMap[T]) => void,
	options?: AddEventListenerOptions,
): void => {
	useEffect(() => {
		document.addEventListener(eventName, handler, options);
		return () => {
			document.removeEventListener(eventName, handler, options);
		};
	}, [eventName, handler, options]);
};

export default useDocumentEvent;
